import { useState } from 'react';
import { Tab } from '@headlessui/react';
import AdminLayout from '../../components/admin/AdminLayout';
import FontSettings from './theme/FontSettings';
import { useTheme } from '../../contexts/ThemeContext';

function classNames(...classes: string[]) {
  return classes.filter(Boolean).join(' ');
}

export default function ThemeSettings() {
  const [fontSize, setFontSize] = useState({ desktop: '16', tablet: '15', mobile: '14' });
  const [lineHeight, setLineHeight] = useState('1.5');
  const [fontWeight, setFontWeight] = useState('400');
  const [letterSpacing, setLetterSpacing] = useState('0');

  const tabs = [
    { name: 'Generale', icon: '⚙️' },
    { name: 'Layout sito', icon: '📱' },
    { name: 'Layout pagine', icon: '📄' },
    { name: 'Layout archivi', icon: '📚' },
    { name: 'Colori', icon: '🎨' },
    { name: 'Font', icon: '✍️' },
    { name: 'Stile pulsanti', icon: '🔘' },
    { name: 'CSS Custom', icon: '💻' },
  ];

  return (
    <AdminLayout title="Impostazioni Tema">
      <div className="bg-white rounded-lg shadow-md flex">
        <Tab.Group vertical>
          {/* Tab List - Sidebar sinistra */}
          <div className="w-64 border-r">
            <Tab.List className="flex flex-col py-2">
              {tabs.map((tab) => (
                <Tab
                  key={tab.name}
                  className={({ selected }) =>
                    classNames(
                      'flex items-center px-4 py-2 text-sm font-medium',
                      'focus:outline-none transition-colors duration-200',
                      selected
                        ? 'bg-green-50 text-pizzaveg border-l-4 border-pizzaveg'
                        : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'
                    )
                  }
                >
                  <span className="mr-3">{tab.icon}</span>
                  {tab.name}
                </Tab>
              ))}
            </Tab.List>
          </div>

          {/* Tab Panels - Contenuto principale */}
          <div className="flex-1 p-6">
            <Tab.Panels>
              {tabs.map((tab, idx) => (
                <Tab.Panel key={idx}>
                  {tab.name === 'Font' && <FontSettings />}
                  {/* ... altri pannelli ... */}
                </Tab.Panel>
              ))}
            </Tab.Panels>
          </div>
        </Tab.Group>
      </div>
    </AdminLayout>
  );
} 